<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <Heading title="Plan" subTitle="Superchargify comes with all-inclusive plans." />
      </div>
    </div>
    <PlanSelector />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import PlanSelector from '@/components/PlanSelector'
import DevelopmentStore from '@/components/DevelopmentStore'
import ShopifyStaffStore from '@/components/ShopifyStaffStore'

export default {
  components: {
    PlanSelector,
    DevelopmentStore,
    ShopifyStaffStore
  },
  computed: mapState([ 'plan' ])
}
</script>
